import { newsAPI } from "../services/api";

// News data service - fetches from backend API
export const getNews = async () => {
  const response = await newsAPI.getAll();
  return response.data || [];
};

// Get recent news (last 3)
export const getRecentNews = async () => {
  const response = await newsAPI.getRecent();
  return response.data || [];
};
